/* eslint-disable @typescript-eslint/ban-ts-ignore */
import copyStringToClipboard from '../utils/copyStringToClipboard';
export default function socialShare() {
    var url = window.location.href;
    var modules = document.querySelectorAll('[data-id="social-share"]');
    var facebookShare = function () {
        window.open("https://www.facebook.com/sharer/sharer.php?u=".concat(url), 'facebook-share-dialog', 'width=800,height=600');
        return false;
    };
    var twitterShare = function () {
        window.open("https://twitter.com/intent/tweet?url=".concat(url), 'twitter-share-dialog', 'width=800,height=600');
        return false;
    };
    var linkedinShare = function () {
        window.open("https://www.linkedin.com/shareArticle?url=".concat(url), 'linkedin-share-dialog', 'width=800,height=600');
        return false;
    };
    var linkShare = function (e) {
        var currentTarget = e.currentTarget;
        currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.classList.remove('copied');
        copyStringToClipboard(url);
        currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.classList.add('copied');
        setTimeout(function () { return currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.classList.remove('copied'); }, 3000);
    };
    var init = function (module) {
        var facebook = module.querySelector('[data-id="share-facebook"]');
        facebook === null || facebook === void 0 ? void 0 : facebook.addEventListener('click', facebookShare);
        var twitter = module.querySelector('[data-id="share-twitter"]');
        twitter === null || twitter === void 0 ? void 0 : twitter.addEventListener('click', twitterShare);
        var linkedin = module.querySelector('[data-id="share-linkedin"]');
        linkedin === null || linkedin === void 0 ? void 0 : linkedin.addEventListener('click', linkedinShare);
        var link = module.querySelector('[data-id="share-link"]');
        // @ts-ignore the right event
        link === null || link === void 0 ? void 0 : link.addEventListener('click', linkShare);
    };
    modules.forEach(function (module) { return init(module); });
}
